import requests from "./httpService";

const WebSliderServices = {

    getWebSlider: async () => {
        return requests.get(`/websiteslider`);
    },
    updateWebSlider: async (id, body) => {
        return requests.patch(`/websiteslider/${id}`, body);
    },

    createWebSlider: async (body) => {
        return requests.post(`/websiteslider`, body);
    },

    deleteWebSlider: async (id) => {
        return requests.delete(`/websiteslider/${id}`);
    },
    updateBanner: async (id, body) => {
        return requests.patch(`/websiteslider/${id}`, body)
    },
    getBanner: async () => {
        return requests.get(`/websiteslider`)
    },
    createBanner: async (body) => {
        return requests.post(`/websiteslider`, body)
    },
    deleteBanner: async (id) => {
        return requests.delete(`/websiteslider/${id}`)
    }
}

export default WebSliderServices;

